<template>
  <v-layout row justify-center>
    <v-dialog v-model="dialog" persistent max-width="600">
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>{{ title }}</v-card-title>
        <v-card-text>{{ message }}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click.native="close">{{ $t('dialog.ok') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
export default {
  data () {
    return {
      dialog: true
    }
  },
  props: {
    type: String,
    title: String,
    message: String
  },
  methods: {
    close () {
      this.dialog = false
      this.$emit('closed')
    }
  }
}
</script>
